export default __webpack_public_path__ + "static/media/ldxapi.js.6e47ade5.ld";